import serverCall from "../serverCall";

const GetGameDetailSingleId = async (id) => {
  try {
    const response = await serverCall.post(`${process.env.REACT_APP_BASE_API_URL}/game/admin/cancel-game/${id}`);
    return response;
  } catch (error) {
    console.log("FacilitySingleId Api error", error);
  }
};

const UpdateGameDetailRequest = async (id, name, isChange) => {
  try {
    const response = await serverCall.put(`/game/admin/update/${id}`, name);
    return response;
  } catch (error) {
    console.log("UpdateGameDetailRequest Api error", error);
  }
};

const UpdateUserRequest = async (id, userId, oldUserId) => {
  console.log(userId);
  return serverCall.put(`/game/admin/updateUser/${id}?newUserId=${userId}&oldUserId=${oldUserId}`);
};

const AddPlayerRequest = async (gameid, userid) => {
  try {
    const response = await serverCall.post(
      `/game/admin/add-player?gameId=${gameid}&userId=${userid}`
    );
    return response;
  } catch (error) {
    console.log("AddPlayerRequest Api error", error);
  }
};

const GetPlayerRequest = async () => {
  try {
    const response = await serverCall.get(`/users/all-user`);
    return response;
  } catch (error) {
    console.log("GetPlayerRequest error", error);
  }
};

const DeletePlayerRequest = async (gameid, userid) => {
  try {
    const response = await serverCall.post(
      `/game/admin/remove-player?gameId=${gameid}&userId=${userid}`
    );
    return response;
  } catch (error) {
    console.log("DeletePlayerRequest Api error", error);
  }
};

const GameDetailData = {
  AddPlayerRequest,
  GetGameDetailSingleId,
  UpdateGameDetailRequest,
  GetPlayerRequest,
  DeletePlayerRequest,
  UpdateUserRequest
};

export default GameDetailData;
